import { EditButton, EmailField, List, ShowButton, useTable } from '@refinedev/antd';
import { BaseRecord } from '@refinedev/core';
import { Space } from 'antd';

import AppTable from '@/components/general/AppTable';
import LinkTextField from '@/components/general/LinkTextField';
import ProtectedCreateButton from '@/components/protected/ProtectedCreateButton';
import { usePermissionContext } from '@/contexts/PermissionContext';
import { useUserContext } from '@/contexts/UserContext';
import { ShippingLabel } from '@/model/Logistic/ShippingLabel/ShippingLabel';

import ShippingLabelsFilter from './ShippingLabelsFilter/ShippingLabelsFilter';

const ShippingLabelsList = () => {
  const { hasPermission } = usePermissionContext();
  const { pageSizePreference } = useUserContext();
  const {
    tableProps,
    filters,
    setFilters,
    setCurrentPage: setCurrent,
  } = useTable<ShippingLabel>({
    syncWithLocation: true,
    queryOptions: {
      refetchInterval: 300000, // 5 minutes
    },
    pagination: {
      pageSize: pageSizePreference,
    },
  });

  return (
    <List
      headerButtons={({ createButtonProps }) => (
        <>
          <ShippingLabelsFilter filters={filters} setFilters={setFilters} setCurrent={setCurrent} />
          <ProtectedCreateButton {...createButtonProps} />
        </>
      )}>
      <AppTable
        {...tableProps}
        rowKey="id"
        scroll={{ x: 1100, y: 'calc(100dvh - 310px)' }}
        className="ShippingLabelsList">
        <AppTable.Column
          dataIndex="id"
          title={'Id'}
          width={50}
          render={value =>
            hasPermission('show') ? (
              <LinkTextField
                withoutColor
                local
                to={`/shipping_labels/show/${value}`}
                label={value}
              />
            ) : (
              <span>{value}</span>
            )
          }
        />
        <AppTable.Column
          title={'Empresa'}
          render={(_, record) => (
            <LinkTextField
              withoutColor
              admin
              to={`/empresas/show/${record.company}`}
              label={record.company_str ?? record.company}
            />
          )}
          width={200}
        />
        <AppTable.Column dataIndex="description" title={'Descripción'} />
        <AppTable.Column
          dataIndex={'email'}
          title={'email'}
          render={(value: any) => <EmailField value={value} />}
          width={230}
        />
        <AppTable.Column dataIndex="phone_number" title={'Numero de Teléfono'} />
        <AppTable.Column dataIndex="address" title={'Dirección'} />
        {(hasPermission('edit') || hasPermission('show')) && (
          <AppTable.Column
            dataIndex="actions"
            width={55}
            fixed="right"
            render={(_, record: BaseRecord) => (
              <Space>
                {hasPermission('edit') ? (
                  <EditButton hideText size="small" recordItemId={record.id} />
                ) : (
                  <ShowButton hideText size="small" recordItemId={record.id} />
                )}
              </Space>
            )}
          />
        )}
      </AppTable>
    </List>
  );
};

export default ShippingLabelsList;
